import Navigation from '../components/core/Navigation.vue';
import Toolbar from '../components/core/Toolbar.vue';
import Message from '../components/core/Messages.vue';

function setupComponents(Vue){
    Vue.component('navigation', Navigation);
    Vue.component('toolbar', Toolbar);
    Vue.component('message', Message);
}

export {
    setupComponents
}
